// extracted by mini-css-extract-plugin
module.exports = {"RV-J":"NA_RV-J__2DZlS"};